import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import baseURL from '../utils/baseURL';
import useAxiosAuth from '../hooks/useAxiosAuth';

const extractError = (error) =>
    error.response?.data?.message || error.message || 'Request failed';

// PUBLIC submit — works logged-in (doctor) or not (landing visitor). useAxiosAuth
// just adds the token when present; the backend route accepts both.
export const submitContactInquiry = createAsyncThunk(
    'contactInquiry/submit',
    async (payload, { rejectWithValue }) => {
        const axiosInstance = useAxiosAuth();
        try {
            const res = await axiosInstance.post(`${baseURL}/contact-inquiry`, payload);
            return res.data.inquiry;
        } catch (error) {
            return rejectWithValue(extractError(error));
        }
    }
);

// Admin — list all contact requests.
export const getContactInquiries = createAsyncThunk(
    'contactInquiry/list',
    async (_, { rejectWithValue }) => {
        const axiosInstance = useAxiosAuth();
        try {
            const res = await axiosInstance.get(`${baseURL}/contact-inquiry`);
            return res.data.inquiries || [];
        } catch (error) {
            return rejectWithValue(extractError(error));
        }
    }
);

// Admin — toggle a request's responded flag.
export const setInquiryResponded = createAsyncThunk(
    'contactInquiry/setResponded',
    async ({ id, responded }, { rejectWithValue }) => {
        const axiosInstance = useAxiosAuth();
        try {
            const res = await axiosInstance.put(`${baseURL}/contact-inquiry/${id}/responded`, { responded });
            return res.data.inquiry;
        } catch (error) {
            return rejectWithValue(extractError(error));
        }
    }
);

const contactInquirySlice = createSlice({
    name: 'contactInquiry',
    initialState: { inquiries: [], loading: false, submitting: false, error: null },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(submitContactInquiry.pending, (s) => { s.submitting = true; s.error = null; })
            .addCase(submitContactInquiry.fulfilled, (s) => { s.submitting = false; })
            .addCase(submitContactInquiry.rejected, (s, a) => { s.submitting = false; s.error = a.payload; })

            .addCase(getContactInquiries.pending, (s) => { s.loading = true; s.error = null; })
            .addCase(getContactInquiries.fulfilled, (s, a) => { s.loading = false; s.inquiries = a.payload; })
            .addCase(getContactInquiries.rejected, (s, a) => { s.loading = false; s.error = a.payload; })

            .addCase(setInquiryResponded.fulfilled, (s, a) => {
                const u = a.payload;
                if (u) s.inquiries = s.inquiries.map((i) => (i.id === u.id ? u : i));
            });
    },
});

export default contactInquirySlice.reducer;
